import { T } from '@tribeplatform/react-components/i18n'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

export function CollectionRootTreeItem() {
  return (
    <div className="flex w-full items-center py-2">
      <div className="flex items-center gap-2">
        <SvgIcon name="folder" />
        <T id="Generics.Collections" defaultMessage="{COLLECTIONS_CC}" />
      </div>
    </div>
  )
}
